import React, {useEffect, useRef, useState} from 'react';

import { ToastMessage, useToast } from './../../../hooks/toast';
import { getRemainingToastMs, getToastDurationMs } from '../../../utils/toastDuration';

import { FiAlertCircle, FiXCircle, FiCheckCircle, FiInfo } from 'react-icons/fi';

import {Container} from './styles';

interface MessageProps{
	message: ToastMessage;
}

const icons:any = {
	info: <FiInfo size={24} />,
	success: <FiCheckCircle size={24} />,
	error: <FiAlertCircle size={24} />,
}

const Toast: React.FC<MessageProps> = ({message}) => {
	const { removeToast } = useToast();
	const durationMs = getToastDurationMs(message);
	const remainingMsRef = useRef(durationMs);
	const startedAtRef = useRef(Date.now());
	const messageIdRef = useRef(message.id);
	const [isPaused, setIsPaused] = useState(false);

	useEffect(() => {
		if (messageIdRef.current !== message.id) {
			messageIdRef.current = message.id;
			remainingMsRef.current = durationMs;
		}

		if (isPaused) {
			return undefined;
		}

		startedAtRef.current = Date.now();
		const timer = window.setTimeout(() => {
			removeToast(message.id);
		}, remainingMsRef.current);

		return () => {
			window.clearTimeout(timer);
			remainingMsRef.current = getRemainingToastMs(
				remainingMsRef.current,
				Date.now() - startedAtRef.current
			);
		};
	}, [durationMs, isPaused, message.id, removeToast]);

	return (
		<Container
			$type={message.type}
			$hasDescription={!!message.description}
			onMouseEnter={() => setIsPaused(true)}
			onMouseLeave={() => setIsPaused(false)}
		>
			{icons[message.type || 'info' ]}

				<div>
					<strong>{message.title}</strong>
					{message.description && (
						<p>{message.description}</p>
					)}
				</div>

				<button type="button" onClick={() => removeToast(message.id)}>
					<FiXCircle size={18} />
				</button>
		</Container>

		);
};

export default Toast;
